import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Lock, ArrowRight } from "lucide-react";
import type { FeatureFlagKey } from "../api/types";

interface Props {
  /** Which flag this page is gating — drives the headline and copy. */
  featureKey: FeatureFlagKey;
}

/**
 * Shown when a user navigates to a route whose feature flag is `false` for
 * their business. Explains the state and links to Settings → Business →
 * General → Features where the toggle lives.
 */
export function FeatureDisabledPage({ featureKey }: Props) {
  const { t } = useTranslation();
  const featureName = t(`features.${featureKey}.label`);
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="max-w-md rounded-2xl bg-white dark:bg-slate-800 p-8 text-center shadow-sm ring-1 ring-slate-200 dark:ring-slate-700">
        <span className="mx-auto mb-4 inline-flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400">
          <Lock className="h-7 w-7" />
        </span>
        <h2 className="text-lg font-semibold text-fg-primary">
          {t("features.disabledPage.title", { feature: featureName })}
        </h2>
        <p className="mt-2 text-sm text-fg-secondary">
          {t("features.disabledPage.description")}
        </p>
        <Link
          to="/settings"
          className="mt-5 inline-flex items-center gap-1.5 rounded-lg bg-accent-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-accent-700"
        >
          {t("features.disabledPage.cta")}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
